import { AboutFourData } from "@/data";
import React from "react";
import Img from "./img";
import about1 from "@/images/aboutPage/about1.jpeg";
import about2 from "@/images/aboutPage/about2.jpeg";
import about3 from "@/images/aboutPage/about3.jpeg";

const AboutFour = () => {
  const { blockTitle } = AboutFourData;
  const { title, text1, text2 } = blockTitle;
  function createMarkup() {
    return { __html: title };
  }
  return (
    <section className="about_style_3_area section_padding">
      <div className="container">
        <div className="row">
          <div className="col-md-4 col-sm-6">
            {/* <div className="about_image_box"></div> */}
            <Img src={about1} className="img-fluid" alt="Responsive image" />
          </div>
          <div className="col-md-3 col-sm-6">
          <Img src={about2} className="img-fluid" alt="Responsive image" />
          </div>
          <div className="col-md-5 col-sm-6">
          <Img src={about3} className="img-fluid" alt="Responsive image" />
          </div>

          <div className="col-md-4 col-sm-6">
            <div className="about_style_3_details">
              <h1 dangerouslySetInnerHTML={createMarkup()} />
            </div>
          </div>
          <div className="col-md-4 col-sm-6">
            <div className="about_style_3_details">
              {/* <div className="about_us_shape">
                <Img src={aboutShape} alt="about shape" className="img-fluid" />
              </div> */}
              <p>{text1}</p>
            </div>
          </div>

          <div className="col-md-4 col-sm-6">
            <div className="about_style_3_details">
              <p>{text2}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutFour;
